import React from 'react';
import '../styles/Login.css';

const Login = () => {
  return (
    <div className="login-container">
      <div className="login-content">
        <h1>Environment Automation</h1>
        <p>Authentication required to access this application.</p>
        <p>You will be redirected to the login page shortly...</p>
      </div>
    </div>
  );
};

export default Login;